import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { NavMenuComponent } from '@appComponents/nav-menu/nav-menu.component'
import { SiteFooterComponent } from '@appComponents/site-footer/site-footer.component'
import { NgxSpinnerComponent } from 'ngx-spinner'

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, NavMenuComponent, NgxSpinnerComponent, SiteFooterComponent],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
   title = 'advantage-4-dealers'
   isIframe = false

   ngOnInit(): void {
      this.isIframe = window !== window.parent && !window.opener // Remove this line to use Angular Universal
   }
}
